/* ================================================== */
/* GOTO → top
/* ================================================== */

$(document).ready(function() {

	$('.goto-top').click(function(e) {
		e.preventDefault();
		$('html, body').animate({ scrollTop: 0 }, 500, 'easeInOutExpo');
	});

});